<div class="preview-container" [style]="themeStyles()">
  @if (composedPage(); as page) {
  <div class="preview-frame">
    <lib-survey-page></lib-survey-page>
  </div>
  } @else if (loading()) {
  <div class="loader">Loading Preview...</div>
  } @else {
  <div class="error">No page selected or found.</div>
  }
</div>